<template>
    <b-modal v-model="showModal" title="DETALLE DE ENTREGA" hide-footer no-gutter>
        <!-- <div slot="modal-header">
            <b-badge variant="primary"><i class="fa fa-info fa-fw"></i></b-badge> 
        </div> -->
        <div v-if="isLoading">Loading...</div>
        <b-list-group id="modalEasylunch" v-else>
            <b-card bg-variant="light" class="text-center" v-if="!data.length">
                <b-icon icon="info-circle-fill" font-scale="4" variant="info"></b-icon>
                <p class="mt-3">Datos no encontrados</p>
            </b-card>
            <b-list-group-item v-for="item in data" :key="item.id">
                <!-- <b-row align-h="end" align-v="center"> -->
                    <!-- <b-col sm="8"> -->
                        <div class="row row-centered-v">
                            <div class="col">
                                <div class="block">{{ item.plan }}</div>
                                <div class="block small">{{ item.fecha_pedido | humanizar_fecha_simple }} </div>
                            </div>
                            <div class="col-tight">
                                <b-badge variant="primary">{{ item.cantidad }} Unidades</b-badge>
                            </div>
                        </div>
                    <!-- </b-col> -->
                    <!-- <b-col sm="auto"> -->
                    <!-- </b-col> -->
                <!-- </b-row> -->
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>


<script>
import axios from 'axios';
import _ from 'lodash';

export default {
    name: 'modalEasylunchEntregaDetalle',
    data() {
        return {
            showModal: false,
            isLoading: true,
            data: [],
        };
    },
    methods: {
        async open(lunchUsuarioPresenciaId, fechaInicio, fechaFin) {
            this.showModal = true;
            if (! await this.fetchData({ lunchUsuarioPresenciaId, fechaInicio, fechaFin }))
                this.showModal = false;
        },
        async fetchData({ lunchUsuarioPresenciaId, fechaInicio, fechaFin }) {
            this.isLoading = true;
            try {
                console.log({ lunchUsuarioPresenciaId, fechaInicio, fechaFin })
                const response = await axios.get('easylunch/lunchdetalleporrestricciones/' + lunchUsuarioPresenciaId + '/' + fechaInicio + '/' + fechaFin)
                this.data = _.get(response, 'data', []);
                this.isLoading = false;
                return true;
            } catch (error) {
                console.error(error);
                this.isLoading = false;
                return false;
            }
        },
    },
};
</script>

<style lang="less">
#modalEasylunch {
    .main {
        font-weight: bold;
    }

    .block {
        text-align: right;
    }

    .small {
        font-size: calc(1em / 1.618);
        text-transform: uppercase;
    }
}
</style>